import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {TreatmentComponent} from './treatment.component';
import {TreatmentFracturesDialogComponent} from './dialogs/treatment-fractures-dialog/treatment-fractures-dialog.component';
import {TreatmentAnesthesiaDialogComponent} from './dialogs/treatment-anesthesia-dialog/treatment-anesthesia-dialog.component';
import {TreatmentXrayDataDialogComponent} from './dialogs/treatment-xray-data-dialog/treatment-xray-data-dialog.component';
import {TreatmentTeethGroupDialogComponent} from './dialogs/treatment-teeth-group-dialog/treatment-teeth-group-dialog.component';
import {TreatmentPerforationDialogComponent} from './dialogs/treatment-perforation-dialog/treatment-perforation-dialog.component';
import {TdoControlsModule} from '../../tdo-controls/tdo-controls.module';
import {MatRadioModule} from '@angular/material/radio';
import {FormsModule} from '@angular/forms';
import {MatTableModule} from '@angular/material/table';
import {MatIconModule} from '@angular/material/icon';
import {DirectivesModule} from '../../directives/directives.module';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatSortModule} from '@angular/material/sort';
import {MatTooltipModule} from '@angular/material/tooltip';
import { TreatmentEndoEditColumnDialogComponent } from './dialogs/treatment-endo-edit-column-dialog/treatment-endo-edit-column-dialog.component';
import { TreatmentEndoEditRowDialogComponent } from './dialogs/treatment-endo-edit-row-dialog/treatment-endo-edit-row-dialog.component';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {DxContextMenuModule} from "devextreme-angular";



@NgModule({
  declarations: [
    TreatmentComponent,
    TreatmentFracturesDialogComponent,
    TreatmentAnesthesiaDialogComponent,
    TreatmentXrayDataDialogComponent,
    TreatmentTeethGroupDialogComponent,
    TreatmentPerforationDialogComponent,
    TreatmentEndoEditColumnDialogComponent,
    TreatmentEndoEditRowDialogComponent,
  ],
  imports: [
    CommonModule,
    TdoControlsModule,
    MatRadioModule,
    FormsModule,
    MatTableModule,
    MatIconModule,
    DirectivesModule,
    MatCheckboxModule,
    MatSortModule,
    MatTooltipModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    DxContextMenuModule
  ],
  exports: [
    TreatmentComponent,
    TreatmentFracturesDialogComponent,
    TreatmentAnesthesiaDialogComponent,
    TreatmentXrayDataDialogComponent,
    TreatmentTeethGroupDialogComponent,
    TreatmentPerforationDialogComponent,
  ]
})
export class TreatmentModule { }
